<script setup>
import { ref } from "vue";
</script>
<template>
    <div>
        <h1>ADMINPANEL</h1>
    </div>
</template>
